import { render } from "./TitlePage.vue?vue&type=template&id=89fb7cc4&scoped=true"
const script = {}

import "./TitlePage.vue?vue&type=style&index=0&id=89fb7cc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89fb7cc4"]])

export default __exports__